export const pastePlugin = definePlugin => definePlugin('paste', [
  'config',
  'gridView',
  'toolbar',
  'pagination',
  'crossPageSelectAll',
  'filterState',
], (config, gridView, toolbar, pagination, crossPageSelectAll, filterState) => {
  const {
    plugins: {
      paste: {
        i18n,
        CopyPaste,
        filterService,
        perfMarker,
      },
    },
  } = config;
  const menuId = 'button-paste';
  const toolbarEditor = toolbar.gridToolbarGroup.toolbarWithItem(menuId);

  function onClick() {
    let pasteView = CopyPaste.paste({
      filterService,
      gridView,
      pgridPlugins: {
        pagination,
        crossPageSelectAll,
        filterState,
      },
      isForVNext: true,
      perfMarker,
    });

    if (pasteView) {
      toolbarEditor.overrideWith(pasteView);
      toolbar.gridToolbarGroup.hideAllToolbars();
      pasteView.once('hide', () => {
        toolbarEditor.restoreToolbar();
        toolbar.gridToolbarGroup.showAllToolbars();
        pasteView = null;

        toolbarEditor.overrideWith(null);
      });
    }
  }
  toolbarEditor.update({
    id: menuId,
    text: i18n.getString('BulkEdit_PasteMenu'),
    onClick,
    hotkeys: {
      win: 'Ctrl-V',
      mac: '\u2318V',
    },
  });

  return {
    onClick,
  };
});
